import axios from "axios";
import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

export default class extends Controller {

  static values = {
    logged: String,
  };

  static targets = [
    "oldFolderName",
    "inputFolderName",
    "closeRenameModal",
    "folderItem",
    "inputCreateErr",
    "deleteFolderName",
    "deleteFolderBtn",
    "input",
    "inputCreateErr",
    "folderDublicateErr",
    "closeCreateModal",
    "inputSelect",
    "inputMoveErr"
  ];
  coockieFolderId = document.cookie
    .split("; ")
    .find((item) => item.includes("folderId"))
    ?.split("=")[1];

  connect() {
    this.subFolderModal = bootstrap.Modal.getOrCreateInstance(document.querySelector('#createSubFolderModal'));
    this.folderModal = new bootstrap.Modal(document.querySelector("#createFolderModal"));
    this.moveSubFolderModal = bootstrap.Modal.getOrCreateInstance(document.querySelector("#moveSubFolderModal"));
    this.searchFolder()
    this.folderItemTargets.forEach((item) => {
      if (item.dataset.folderId === this.coockieFolderId) {
        item.classList.toggle("active-folder");
        item.querySelector("#folderIc").href.baseVal =
          "/static/pages/admin-img/symbol.svg#icon-open-folder";
      }
    });
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("archived")) {
      this.folderItemTargets.forEach((item) => item.classList.add("d-none"));
    }
  }

  getFolderName(e) {
    this.oldFolderNameTarget.innerHTML = e.currentTarget.dataset.folder;
    this.oldFolderNameTarget.dataset.folderId =
      e.currentTarget.dataset.folderId;
  }

  renameFolder() {
    if (!this.inputFolderNameTarget.value.trim().length) {
      this.inputCreateErrTarget.classList.remove("d-none");
      setTimeout(() => this.inputCreateErrTarget.classList.add("d-none"), 5000);
      return;
    }
    const formData = new FormData();
    formData.append("name", this.inputFolderNameTarget.value);
    try {
      axios
        .post(
          `/folder/edit/${this.oldFolderNameTarget.dataset.folderId}`,
          formData
        )
        .then(() => {
          this.closeRenameModalTarget.click();
          window.location.reload();
        });
    } catch (err) {}
  }

  deleteFolder(e) {
    this.deleteFolderNameTargets.forEach(
      (item) => (item.innerHTML = e.currentTarget.dataset.folderName)
    );
    this.deleteFolderBtnTarget.dataset.folderId =
      e.currentTarget.dataset.folderId;
  }

  deleteFolderBtn(e) {
    e.preventDefault();
    try {
      axios
        .post(`/folder/delete/${e.currentTarget.dataset.folderId}`)
        .then(() => {
          document.cookie =
            "folderId" + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
          window.location.reload();
        });
    } catch (err) {}
  }

  openFolder(e) {
    const cuttentFolderId = e.currentTarget.dataset.folderId;
    const href = e.currentTarget.dataset.href;
    if (
      !(
        e.currentTarget === e.target ||
        e.target.id === "dataFolder" ||
        e.target.parentElement.id === "dataFolder"
      )
    ) {
      return;
    }
    const preloader = document.querySelector(".loaderWrapper");
    preloader.classList.remove("d-none");
    axios(`/entry/filterByFolder/${cuttentFolderId}`)
      .then(() => {
        document.cookie =
          "filterByType" + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
        window.location.href = href;
      })
      .catch(() => preloader.classList.add("d-none"));
  }

  closeFolder() {
    document.cookie =
      "folderId" + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  }

  createFolderModal(e) {
    if (this.loggedValue.length) {
      this.folderModal.show();
    } else {
      window.location.href = e.currentTarget.dataset.login;
    }
  }
  createSubFolderModal(event) {
    this.parentIdValue = event.currentTarget.dataset.parentId;
      this.subFolderModal.show();
      const createSubBtn = document.querySelector("#createSubBtn");
      createSubBtn.dataset.parentId = this.parentIdValue
  }

  async createSubFolder(event) {
    if (!this.inputTarget.value.trim().length) {
      this.showErrorMsg(this.inputCreateErrTarget);
      return;
    }

    this.parentIdValue = event.currentTarget.dataset.parentId;
    const formData = new FormData();
    formData.append("name", this.inputTarget.value);

    try {
      const { data } = await axios.post(`folder/subfolder/${this.parentIdValue}/create`, formData);
      this.closeCreateModalTarget.click();
      window.location.reload();

    } catch (error) {
      if (error.response && error.response.data) {
        const serverError = error.response.data.error || error.response.data.message;
        console.error(serverError);
        if (serverError === "Folder name already exists") {
          this.showErrorMsg(this.folderDublicateErrTarget);
        } else {
          this.showErrorMsg(this.inputCreateErrTarget);
        }

      } else {
        console.error( error.message);
      }
    }
  }
  showErrorMsg(target) {
    target.classList.remove("d-none");
    setTimeout(() => target.classList.add("d-none"), 5000);
  }

  closeModal() {
    this.folderModal.hide();
    this.subFolderModal.hide();
  }
  createMoveSubFolderModal(event) {
    this.parentIdValue = event.currentTarget.dataset.folderId;
    this.IdValue = event.currentTarget.dataset.id;
    this.moveSubFolderModal.show();

    const moveSubBtn = document.querySelector("#moveSubBtn");
      moveSubBtn.dataset.folderId = this.parentIdValue
      moveSubBtn.dataset.id = this.IdValue
  }
  async moveSubFolder(event) {
    this.newParentIdValue = this.inputSelectTarget.value;
    this.parentIdValue = event.currentTarget.dataset.folderId;
    this.IdValue = event.currentTarget.dataset.id;
    if (this.newParentIdValue === this.parentIdValue) {
      this.showErrorMsg(this.inputMoveErrTarget)
      return;
    }
    try {
      const { data } = await axios.get(`folder/move/${this.newParentIdValue}/${this.IdValue}`);
      this.closeCreateModalTarget.click();
      window.location.reload();

    } catch (error) {
      if (error.response && error.response.data) {
        console.error(error.response.data.message);
      } else {
        console.error(error.message);
      }
    }
  }
  downloadFolderInit(e) {
    const downloadFolderBtn = document.querySelector("#downloadFolderBtn");
    if (!downloadFolderBtn) {
      return;
    }
    let folderReportId = e.target.dataset.folderReportId
    downloadFolderBtn.dataset.folderId = e.target.dataset.folderId;
    downloadFolderBtn.dataset.folder = e.target.dataset.folder;
    downloadFolderBtn.dataset.folderReportId = folderReportId;

    folderReportId = +folderReportId;
    if (folderReportId === 0) {
      const downloadFolderBtn = document.querySelector("#deleteFolderReportBtn");
      if (downloadFolderBtn) {
        downloadFolderBtn.classList.add("d-none");
      }
    }
  }
  javascript

  searchFolder() {
    if (window.folderSearchInitialized) return;
    window.folderSearchInitialized = true;

    document.addEventListener('DOMContentLoaded', () => {
      const folderLists = document.querySelectorAll('.folder-list');
      if (!folderLists.length) {
        return;
      }

      folderLists.forEach((folderList) => {
        const noMatchesElement = document.createElement('div');
        noMatchesElement.className = 'py-2 text-center text-muted fs-7 d-none';
        noMatchesElement.textContent = 'No Folder Found';
        folderList.appendChild(noMatchesElement);

        const folderElements = folderList.querySelectorAll('.folder-name');
        folderElements.forEach((element, index) => {

          if (folderElements.length > 7 && index >= 7) {
            element.classList.add('d-none');
          }
        });
      });

      const applySearchFilter = (searchTerm, limitToFour = false) => {
        folderLists.forEach((folderList) => {
          const folders = JSON.parse(folderList.dataset.folders || '[]');
          const folderElements = folderList.querySelectorAll('.folder-name');
          const noMatchesElement = folderList.querySelector('.py-2.text-center.text-muted.fs-7');

          let hasMatches = false;

          const normalizedSearchTerm = searchTerm.toLowerCase().trim();


          folderElements.forEach((element, index) => {
            const folderName = (element.dataset.folderName || '').toLowerCase().trim();


            let shouldHide = normalizedSearchTerm && !folderName.includes(normalizedSearchTerm);

            if (!normalizedSearchTerm && limitToFour && folderElements.length > 7 && index >= 7) {
              shouldHide = true;
            }

            element.style.display = '';
            element.classList.toggle('d-none', shouldHide);
          });

          const shouldShowNoMatches = normalizedSearchTerm !== '' && !hasMatches;
          noMatchesElement.style.display = '';
          noMatchesElement.classList.toggle('d-none', !shouldShowNoMatches);
        });
      };

      document.body.addEventListener('input', (e) => {
        if (!e.target.classList.contains('search-folder-input')) return;

        const searchTerm = e.target.value.toLowerCase().trim();
        const viewAllBtn = document.querySelector('.view-all-btn');
        const isViewAll = viewAllBtn?.dataset.state === 'view-all';

        applySearchFilter(searchTerm, isViewAll);
      });

      document.body.addEventListener('click', (e) => {
        if (!e.target.classList.contains('view-all-btn')) return;

        const isViewAll = e.target.dataset.state === 'view-all';
        const buttons = document.querySelectorAll('.view-all-btn');

        if (isViewAll) {
          folderLists.forEach((folderList) => {
            const folderElements = folderList.querySelectorAll('.folder-name');
            const noMatchesElement = folderList.querySelector('.py-2.text-center.text-muted.fs-7');

            folderElements.forEach((element) => {
              element.style.display = '';
              element.classList.remove('d-none');
            });

            noMatchesElement.style.display = '';
            noMatchesElement.classList.add('d-none');
          });

          buttons.forEach((btn) => {
            btn.textContent = 'Hide';
            btn.dataset.state = 'hide';
          });
        } else {
          const searchTerm = document.querySelector('.search-folder-input')?.value.toLowerCase().trim() || '';
          applySearchFilter(searchTerm, true);

          buttons.forEach((btn) => {
            btn.textContent = 'View All';
            btn.dataset.state = 'view-all';
          });
        }
      });
    });
  }
}
